import React from 'react';
import Magnifier from "react-magnifier";


export default function ExampleComponent(props) {
    const yourImage = props.imgZoom.imgToZoom;
    const MagnifiedImage=props.imgZoom.zoomMagImg;
    return <Magnifier src={yourImage} width={"100%"} zoomFactor={1.2} mgWidth={300} mgHeight={300} mgShape={"circle"} mgBorderWidth	={5} zoomImgSrc={MagnifiedImage}/>;
}